import { useAppSelector } from "@/redux/store";
import React, { useState } from "react";
import Img from "react-image";
import { useLocation } from "react-router-dom";
import { selectProductDetails } from "../selectors";

const HoverImage = ({
  handleImageMouseOut,
  handleImageMouseMove,
  forwardRef,
  zoomedBlockRef,
  url,
  hoverImg
}) => {
  const [imageSrc, setImageSrc] = useState("");
  const [cx, setCx] = useState(0);
  const [cy, setCy] = useState(0);
  const [lensXOffset, setLensXOffset] = useState(0);
  const [lensYOffset, setLensYOffset] = useState(0);
  const [xPosition, setXPosition] = useState(0);
  const [yPosition, setYPosition] = useState(0);
  const product = useAppSelector(selectProductDetails);

  const { state } = useLocation<{ fromPLP?: boolean }>();
  const isFromPLP = state?.fromPLP;

  const replaceSpace = name => {
    try {
      return name.replace(/ /g, "%20");
    } catch (error) {
      return name;
    }
  };

  const hoverImgSrc = replaceSpace(hoverImg);

  const handleMouseMove = (e, imgUrl) => {
    const containerHeight = forwardRef?.firstElementChild?.offsetHeight;

    const imgHeight = e?.target?.naturalHeight;

    if (imgHeight && containerHeight && imgHeight < containerHeight) {
      forwardRef.firstElementChild.classList.add("hideZoom");
      return null;
    } else {
      forwardRef.firstElementChild.classList.remove("hideZoom");
    }
    const { height, width } = e.target.getBoundingClientRect();

    const rect = e.target.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const centeredX = x - lensXOffset;
    const centeredY = y - lensYOffset;

    if (zoomedBlockRef && zoomedBlockRef.current) {
      const zoomedRect = zoomedBlockRef.current.getBoundingClientRect();

      if (imgUrl !== imageSrc) {
        const zoomedImage = new Image();
        zoomedImage.src = imgUrl;
        zoomedImage.onload = () => {
          const newImageWidth = zoomedImage.width;
          const newImageHeight = zoomedImage.height;
          const cx = newImageWidth / width;
          const cy = newImageHeight / height;
          const lensYOffset = (0.5 * zoomedRect.height) / cy;
          const lensXOffset = (0.5 * zoomedRect.width) / cx;

          setImageSrc(imgUrl);
          setCx(cx);
          setCy(cy);
          setLensYOffset(lensYOffset);
          setLensXOffset(lensXOffset);
        };
      }
    }
    let newXPosition = -centeredX * cx;
    let newYPosition = -centeredY * cy;

    if (centeredX < 0 || x > width - lensXOffset) {
      newXPosition = xPosition;
    }

    if (centeredY < 0 || y > height - lensYOffset) {
      newYPosition = yPosition;
    }

    if (handleImageMouseMove) {
      handleImageMouseMove({
        backgroundImage: imgUrl,
        isHover: true,
        backgroundPosition: `${newXPosition}px ${newYPosition}px`
      });
    }

    setXPosition(newXPosition);
    setYPosition(newYPosition);
  };

  return (
    <div
      onMouseMove={e => handleMouseMove(e, `${url?.full}${hoverImgSrc}`)}
      onMouseOut={handleImageMouseOut}
      className="swiper-slide"
    >
      <Img
        decode={false}
        loader={
          <img
            style={{ width: "100%", height: "100%" }}
            src={`${isFromPLP ? url?.list : url?.thumb}${hoverImgSrc}`}
          />
        }
        src={`${url?.full}${hoverImgSrc}`}
        alt={product.title?.label}
      />
    </div>
  );
};

export default HoverImage;
